"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/dashboard/v1/legacy_portal_common.proto (package spwn.dashboard.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPortalDashboardTicketQuestionnaireTextAnswer = exports.LegacyPortalDashboardTicketQuestionnaireTicketAnswerAggregation = exports.LegacyPortalDashboardTicketQuestionnaireTicket = exports.LegacyPortalDashboardTicketQuestionnaireAnswerCount = exports.LegacyPortalDashboardTicketQuestionnaireTextAnswers = exports.LegacyPortalDashboardTicketQuestionnaireSelectAnswerAggregation = exports.LegacyPortalDashboardTicketQuestionnaireQuestion = exports.LegacyPortalDashboardPrefectureCount = exports.LegacyPortalDashboardAgeGroupGenderCount = exports.LegacyPortalDashboardGenderCount = exports.LegacyPortalDashboardTicketSalesByOrderDate = exports.LegacyPortalDashboardEventSalesDetail = exports.LegacyPortalIssuedTicketsSummary = exports.LegacyPortalDashboardTicketQuestionAnswerType = exports.LegacyPortalDashboardPrefecture = exports.LegacyPortalDashboardAgeGroup = exports.LegacyPortalDashboardGender = exports.LegacyPortalDashboardProductType = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from enum spwn.dashboard.v1.LegacyPortalDashboardProductType
 */
var LegacyPortalDashboardProductType;
(function (LegacyPortalDashboardProductType) {
    /**
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PRODUCT_TYPE_UNSPECIFIED = 0;
     */
    LegacyPortalDashboardProductType[LegacyPortalDashboardProductType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 配信チケット
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PRODUCT_TYPE_STREAMING_TICKET = 1;
     */
    LegacyPortalDashboardProductType[LegacyPortalDashboardProductType["STREAMING_TICKET"] = 1] = "STREAMING_TICKET";
    /**
     * 会場チケット
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PRODUCT_TYPE_VENUE_TICKET = 2;
     */
    LegacyPortalDashboardProductType[LegacyPortalDashboardProductType["VENUE_TICKET"] = 2] = "VENUE_TICKET";
    /**
     * グッズ
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PRODUCT_TYPE_GOODS = 3;
     */
    LegacyPortalDashboardProductType[LegacyPortalDashboardProductType["GOODS"] = 3] = "GOODS";
    /**
     * デジタルコンテンツ
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PRODUCT_TYPE_DIGITAL_CONTENT = 4;
     */
    LegacyPortalDashboardProductType[LegacyPortalDashboardProductType["DIGITAL_CONTENT"] = 4] = "DIGITAL_CONTENT";
    /**
     * 投げ銭
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PRODUCT_TYPE_TIP = 5;
     */
    LegacyPortalDashboardProductType[LegacyPortalDashboardProductType["TIP"] = 5] = "TIP";
})(LegacyPortalDashboardProductType || (exports.LegacyPortalDashboardProductType = LegacyPortalDashboardProductType = {}));
// Retrieve enum metadata with: proto3.getEnumType(LegacyPortalDashboardProductType)
protobuf_1.proto3.util.setEnumType(LegacyPortalDashboardProductType, "spwn.dashboard.v1.LegacyPortalDashboardProductType", [
    { no: 0, name: "LEGACY_PORTAL_DASHBOARD_PRODUCT_TYPE_UNSPECIFIED" },
    { no: 1, name: "LEGACY_PORTAL_DASHBOARD_PRODUCT_TYPE_STREAMING_TICKET" },
    { no: 2, name: "LEGACY_PORTAL_DASHBOARD_PRODUCT_TYPE_VENUE_TICKET" },
    { no: 3, name: "LEGACY_PORTAL_DASHBOARD_PRODUCT_TYPE_GOODS" },
    { no: 4, name: "LEGACY_PORTAL_DASHBOARD_PRODUCT_TYPE_DIGITAL_CONTENT" },
    { no: 5, name: "LEGACY_PORTAL_DASHBOARD_PRODUCT_TYPE_TIP" },
]);
/**
 * @generated from enum spwn.dashboard.v1.LegacyPortalDashboardGender
 */
var LegacyPortalDashboardGender;
(function (LegacyPortalDashboardGender) {
    /**
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_GENDER_UNSPECIFIED = 0;
     */
    LegacyPortalDashboardGender[LegacyPortalDashboardGender["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 男性
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_GENDER_MALE = 1;
     */
    LegacyPortalDashboardGender[LegacyPortalDashboardGender["MALE"] = 1] = "MALE";
    /**
     * 女性
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_GENDER_FEMALE = 2;
     */
    LegacyPortalDashboardGender[LegacyPortalDashboardGender["FEMALE"] = 2] = "FEMALE";
    /**
     * その他
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_GENDER_OTHER = 3;
     */
    LegacyPortalDashboardGender[LegacyPortalDashboardGender["OTHER"] = 3] = "OTHER";
    /**
     * 未回答
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_GENDER_NO_ANSWER = 4;
     */
    LegacyPortalDashboardGender[LegacyPortalDashboardGender["NO_ANSWER"] = 4] = "NO_ANSWER";
})(LegacyPortalDashboardGender || (exports.LegacyPortalDashboardGender = LegacyPortalDashboardGender = {}));
// Retrieve enum metadata with: proto3.getEnumType(LegacyPortalDashboardGender)
protobuf_1.proto3.util.setEnumType(LegacyPortalDashboardGender, "spwn.dashboard.v1.LegacyPortalDashboardGender", [
    { no: 0, name: "LEGACY_PORTAL_DASHBOARD_GENDER_UNSPECIFIED" },
    { no: 1, name: "LEGACY_PORTAL_DASHBOARD_GENDER_MALE" },
    { no: 2, name: "LEGACY_PORTAL_DASHBOARD_GENDER_FEMALE" },
    { no: 3, name: "LEGACY_PORTAL_DASHBOARD_GENDER_OTHER" },
    { no: 4, name: "LEGACY_PORTAL_DASHBOARD_GENDER_NO_ANSWER" },
]);
/**
 * @generated from enum spwn.dashboard.v1.LegacyPortalDashboardAgeGroup
 */
var LegacyPortalDashboardAgeGroup;
(function (LegacyPortalDashboardAgeGroup) {
    /**
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_AGE_GROUP_UNSPECIFIED = 0;
     */
    LegacyPortalDashboardAgeGroup[LegacyPortalDashboardAgeGroup["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 10歳未満
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_AGE_GROUP_UNDER_10 = 1;
     */
    LegacyPortalDashboardAgeGroup[LegacyPortalDashboardAgeGroup["UNDER_10"] = 1] = "UNDER_10";
    /**
     * 10歳以上19歳以下
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_AGE_GROUP_FROM_10_TO_19 = 2;
     */
    LegacyPortalDashboardAgeGroup[LegacyPortalDashboardAgeGroup["FROM_10_TO_19"] = 2] = "FROM_10_TO_19";
    /**
     * 20歳以上29歳以下
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_AGE_GROUP_FROM_20_TO_29 = 3;
     */
    LegacyPortalDashboardAgeGroup[LegacyPortalDashboardAgeGroup["FROM_20_TO_29"] = 3] = "FROM_20_TO_29";
    /**
     * 30歳以上39歳以下
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_AGE_GROUP_FROM_30_TO_39 = 4;
     */
    LegacyPortalDashboardAgeGroup[LegacyPortalDashboardAgeGroup["FROM_30_TO_39"] = 4] = "FROM_30_TO_39";
    /**
     * 40歳以上49歳以下
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_AGE_GROUP_FROM_40_TO_49 = 5;
     */
    LegacyPortalDashboardAgeGroup[LegacyPortalDashboardAgeGroup["FROM_40_TO_49"] = 5] = "FROM_40_TO_49";
    /**
     * 50歳以上59歳以下
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_AGE_GROUP_FROM_50_TO_59 = 6;
     */
    LegacyPortalDashboardAgeGroup[LegacyPortalDashboardAgeGroup["FROM_50_TO_59"] = 6] = "FROM_50_TO_59";
    /**
     * 60歳以上69歳以下
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_AGE_GROUP_FROM_60_TO_69 = 7;
     */
    LegacyPortalDashboardAgeGroup[LegacyPortalDashboardAgeGroup["FROM_60_TO_69"] = 7] = "FROM_60_TO_69";
    /**
     * 70歳以上
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_AGE_GROUP_OVER_70 = 8;
     */
    LegacyPortalDashboardAgeGroup[LegacyPortalDashboardAgeGroup["OVER_70"] = 8] = "OVER_70";
    /**
     * 未回答
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_AGE_GROUP_NO_ANSWER = 9;
     */
    LegacyPortalDashboardAgeGroup[LegacyPortalDashboardAgeGroup["NO_ANSWER"] = 9] = "NO_ANSWER";
})(LegacyPortalDashboardAgeGroup || (exports.LegacyPortalDashboardAgeGroup = LegacyPortalDashboardAgeGroup = {}));
// Retrieve enum metadata with: proto3.getEnumType(LegacyPortalDashboardAgeGroup)
protobuf_1.proto3.util.setEnumType(LegacyPortalDashboardAgeGroup, "spwn.dashboard.v1.LegacyPortalDashboardAgeGroup", [
    { no: 0, name: "LEGACY_PORTAL_DASHBOARD_AGE_GROUP_UNSPECIFIED" },
    { no: 1, name: "LEGACY_PORTAL_DASHBOARD_AGE_GROUP_UNDER_10" },
    { no: 2, name: "LEGACY_PORTAL_DASHBOARD_AGE_GROUP_FROM_10_TO_19" },
    { no: 3, name: "LEGACY_PORTAL_DASHBOARD_AGE_GROUP_FROM_20_TO_29" },
    { no: 4, name: "LEGACY_PORTAL_DASHBOARD_AGE_GROUP_FROM_30_TO_39" },
    { no: 5, name: "LEGACY_PORTAL_DASHBOARD_AGE_GROUP_FROM_40_TO_49" },
    { no: 6, name: "LEGACY_PORTAL_DASHBOARD_AGE_GROUP_FROM_50_TO_59" },
    { no: 7, name: "LEGACY_PORTAL_DASHBOARD_AGE_GROUP_FROM_60_TO_69" },
    { no: 8, name: "LEGACY_PORTAL_DASHBOARD_AGE_GROUP_OVER_70" },
    { no: 9, name: "LEGACY_PORTAL_DASHBOARD_AGE_GROUP_NO_ANSWER" },
]);
/**
 * @generated from enum spwn.dashboard.v1.LegacyPortalDashboardPrefecture
 */
var LegacyPortalDashboardPrefecture;
(function (LegacyPortalDashboardPrefecture) {
    /**
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_UNSPECIFIED = 0;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 北海道
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_HOKKAIDO = 1;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["HOKKAIDO"] = 1] = "HOKKAIDO";
    /**
     * 青森県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_AOMORI = 2;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["AOMORI"] = 2] = "AOMORI";
    /**
     * 岩手県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_IWATE = 3;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["IWATE"] = 3] = "IWATE";
    /**
     * 宮城県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_MIYAGI = 4;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["MIYAGI"] = 4] = "MIYAGI";
    /**
     * 秋田県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_AKITA = 5;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["AKITA"] = 5] = "AKITA";
    /**
     * 山形県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_YAMAGATA = 6;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["YAMAGATA"] = 6] = "YAMAGATA";
    /**
     * 福島県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_FUKUSHIMA = 7;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["FUKUSHIMA"] = 7] = "FUKUSHIMA";
    /**
     * 茨城県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_IBARAKI = 8;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["IBARAKI"] = 8] = "IBARAKI";
    /**
     * 栃木県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_TOCHIGI = 9;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["TOCHIGI"] = 9] = "TOCHIGI";
    /**
     * 群馬県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_GUNMA = 10;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["GUNMA"] = 10] = "GUNMA";
    /**
     * 埼玉県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_SAITAMA = 11;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["SAITAMA"] = 11] = "SAITAMA";
    /**
     * 千葉県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_CHIBA = 12;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["CHIBA"] = 12] = "CHIBA";
    /**
     * 東京都
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_TOKYO = 13;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["TOKYO"] = 13] = "TOKYO";
    /**
     * 神奈川県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_KANAGAWA = 14;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["KANAGAWA"] = 14] = "KANAGAWA";
    /**
     * 新潟県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_NIIGATA = 15;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["NIIGATA"] = 15] = "NIIGATA";
    /**
     * 富山県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_TOYAMA = 16;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["TOYAMA"] = 16] = "TOYAMA";
    /**
     * 石川県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_ISHIKAWA = 17;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["ISHIKAWA"] = 17] = "ISHIKAWA";
    /**
     * 福井県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_FUKUI = 18;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["FUKUI"] = 18] = "FUKUI";
    /**
     * 山梨県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_YAMANASHI = 19;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["YAMANASHI"] = 19] = "YAMANASHI";
    /**
     * 長野県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_NAGANO = 20;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["NAGANO"] = 20] = "NAGANO";
    /**
     * 岐阜県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_GIFU = 21;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["GIFU"] = 21] = "GIFU";
    /**
     * 静岡県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_SHIZUOKA = 22;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["SHIZUOKA"] = 22] = "SHIZUOKA";
    /**
     * 愛知県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_AICHI = 23;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["AICHI"] = 23] = "AICHI";
    /**
     * 三重県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_MIE = 24;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["MIE"] = 24] = "MIE";
    /**
     * 滋賀県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_SHIGA = 25;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["SHIGA"] = 25] = "SHIGA";
    /**
     * 京都府
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_KYOTO = 26;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["KYOTO"] = 26] = "KYOTO";
    /**
     * 大阪府
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_OSAKA = 27;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["OSAKA"] = 27] = "OSAKA";
    /**
     * 兵庫県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_HYOGO = 28;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["HYOGO"] = 28] = "HYOGO";
    /**
     * 奈良県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_NARA = 29;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["NARA"] = 29] = "NARA";
    /**
     * 和歌山県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_WAKAYAMA = 30;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["WAKAYAMA"] = 30] = "WAKAYAMA";
    /**
     * 鳥取県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_TOTTORI = 31;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["TOTTORI"] = 31] = "TOTTORI";
    /**
     * 島根県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_SHIMANE = 32;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["SHIMANE"] = 32] = "SHIMANE";
    /**
     * 岡山県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_OKAYAMA = 33;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["OKAYAMA"] = 33] = "OKAYAMA";
    /**
     * 広島県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_HIROSHIMA = 34;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["HIROSHIMA"] = 34] = "HIROSHIMA";
    /**
     * 山口県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_YAMAGUCHI = 35;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["YAMAGUCHI"] = 35] = "YAMAGUCHI";
    /**
     * 徳島県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_TOKUSHIMA = 36;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["TOKUSHIMA"] = 36] = "TOKUSHIMA";
    /**
     * 香川県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_KAGAWA = 37;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["KAGAWA"] = 37] = "KAGAWA";
    /**
     * 愛媛県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_EHIME = 38;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["EHIME"] = 38] = "EHIME";
    /**
     * 高知県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_KOCHI = 39;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["KOCHI"] = 39] = "KOCHI";
    /**
     * 福岡県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_FUKUOKA = 40;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["FUKUOKA"] = 40] = "FUKUOKA";
    /**
     * 佐賀県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_SAGA = 41;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["SAGA"] = 41] = "SAGA";
    /**
     * 長崎県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_NAGASAKI = 42;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["NAGASAKI"] = 42] = "NAGASAKI";
    /**
     * 熊本県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_KUMAMOTO = 43;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["KUMAMOTO"] = 43] = "KUMAMOTO";
    /**
     * 大分県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_OITA = 44;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["OITA"] = 44] = "OITA";
    /**
     * 宮崎県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_MIYAZAKI = 45;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["MIYAZAKI"] = 45] = "MIYAZAKI";
    /**
     * 鹿児島県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_KAGOSHIMA = 46;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["KAGOSHIMA"] = 46] = "KAGOSHIMA";
    /**
     * 沖縄県
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_OKINAWA = 47;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["OKINAWA"] = 47] = "OKINAWA";
    /**
     * 未回答
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_PREFECTURE_NO_ANSWER = 48;
     */
    LegacyPortalDashboardPrefecture[LegacyPortalDashboardPrefecture["NO_ANSWER"] = 48] = "NO_ANSWER";
})(LegacyPortalDashboardPrefecture || (exports.LegacyPortalDashboardPrefecture = LegacyPortalDashboardPrefecture = {}));
// Retrieve enum metadata with: proto3.getEnumType(LegacyPortalDashboardPrefecture)
protobuf_1.proto3.util.setEnumType(LegacyPortalDashboardPrefecture, "spwn.dashboard.v1.LegacyPortalDashboardPrefecture", [
    { no: 0, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_UNSPECIFIED" },
    { no: 1, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_HOKKAIDO" },
    { no: 2, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_AOMORI" },
    { no: 3, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_IWATE" },
    { no: 4, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_MIYAGI" },
    { no: 5, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_AKITA" },
    { no: 6, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_YAMAGATA" },
    { no: 7, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_FUKUSHIMA" },
    { no: 8, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_IBARAKI" },
    { no: 9, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_TOCHIGI" },
    { no: 10, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_GUNMA" },
    { no: 11, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_SAITAMA" },
    { no: 12, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_CHIBA" },
    { no: 13, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_TOKYO" },
    { no: 14, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_KANAGAWA" },
    { no: 15, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_NIIGATA" },
    { no: 16, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_TOYAMA" },
    { no: 17, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_ISHIKAWA" },
    { no: 18, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_FUKUI" },
    { no: 19, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_YAMANASHI" },
    { no: 20, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_NAGANO" },
    { no: 21, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_GIFU" },
    { no: 22, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_SHIZUOKA" },
    { no: 23, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_AICHI" },
    { no: 24, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_MIE" },
    { no: 25, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_SHIGA" },
    { no: 26, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_KYOTO" },
    { no: 27, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_OSAKA" },
    { no: 28, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_HYOGO" },
    { no: 29, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_NARA" },
    { no: 30, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_WAKAYAMA" },
    { no: 31, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_TOTTORI" },
    { no: 32, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_SHIMANE" },
    { no: 33, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_OKAYAMA" },
    { no: 34, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_HIROSHIMA" },
    { no: 35, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_YAMAGUCHI" },
    { no: 36, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_TOKUSHIMA" },
    { no: 37, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_KAGAWA" },
    { no: 38, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_EHIME" },
    { no: 39, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_KOCHI" },
    { no: 40, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_FUKUOKA" },
    { no: 41, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_SAGA" },
    { no: 42, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_NAGASAKI" },
    { no: 43, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_KUMAMOTO" },
    { no: 44, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_OITA" },
    { no: 45, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_MIYAZAKI" },
    { no: 46, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_KAGOSHIMA" },
    { no: 47, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_OKINAWA" },
    { no: 48, name: "LEGACY_PORTAL_DASHBOARD_PREFECTURE_NO_ANSWER" },
]);
/**
 * @generated from enum spwn.dashboard.v1.LegacyPortalDashboardTicketQuestionAnswerType
 */
var LegacyPortalDashboardTicketQuestionAnswerType;
(function (LegacyPortalDashboardTicketQuestionAnswerType) {
    /**
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_TICKET_QUESTION_ANSWER_TYPE_UNSPECIFIED = 0;
     */
    LegacyPortalDashboardTicketQuestionAnswerType[LegacyPortalDashboardTicketQuestionAnswerType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 選択式の設問
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_TICKET_QUESTION_ANSWER_TYPE_SELECT = 1;
     */
    LegacyPortalDashboardTicketQuestionAnswerType[LegacyPortalDashboardTicketQuestionAnswerType["SELECT"] = 1] = "SELECT";
    /**
     * 自由記入の設問
     *
     * @generated from enum value: LEGACY_PORTAL_DASHBOARD_TICKET_QUESTION_ANSWER_TYPE_TEXT = 2;
     */
    LegacyPortalDashboardTicketQuestionAnswerType[LegacyPortalDashboardTicketQuestionAnswerType["TEXT"] = 2] = "TEXT";
})(LegacyPortalDashboardTicketQuestionAnswerType || (exports.LegacyPortalDashboardTicketQuestionAnswerType = LegacyPortalDashboardTicketQuestionAnswerType = {}));
// Retrieve enum metadata with: proto3.getEnumType(LegacyPortalDashboardTicketQuestionAnswerType)
protobuf_1.proto3.util.setEnumType(LegacyPortalDashboardTicketQuestionAnswerType, "spwn.dashboard.v1.LegacyPortalDashboardTicketQuestionAnswerType", [
    { no: 0, name: "LEGACY_PORTAL_DASHBOARD_TICKET_QUESTION_ANSWER_TYPE_UNSPECIFIED" },
    { no: 1, name: "LEGACY_PORTAL_DASHBOARD_TICKET_QUESTION_ANSWER_TYPE_SELECT" },
    { no: 2, name: "LEGACY_PORTAL_DASHBOARD_TICKET_QUESTION_ANSWER_TYPE_TEXT" },
]);
/**
 * ダッシュボードに表示するチケットの情報
 *
 * @generated from message spwn.dashboard.v1.LegacyPortalIssuedTicketsSummary
 */
class LegacyPortalIssuedTicketsSummary extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string ticket_id = 1;
         */
        this.ticketId = "";
        /**
         * @generated from field: string ticket_name = 2;
         */
        this.ticketName = "";
        /**
         * @generated from field: int32 purchased_count = 3;
         */
        this.purchasedCount = 0;
        /**
         * @generated from field: int32 checked_in_count = 4;
         */
        this.checkedInCount = 0;
        /**
         * @generated from field: double checked_in_rate = 5;
         */
        this.checkedInRate = 0;
        /**
         * @generated from field: int32 redeemable_count = 6;
         */
        this.redeemableCount = 0;
        /**
         * @generated from field: int32 redeemed_count = 7;
         */
        this.redeemedCount = 0;
        /**
         * @generated from field: double redeemed_rate = 8;
         */
        this.redeemedRate = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalIssuedTicketsSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalIssuedTicketsSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalIssuedTicketsSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalIssuedTicketsSummary, a, b);
    }
}
exports.LegacyPortalIssuedTicketsSummary = LegacyPortalIssuedTicketsSummary;
LegacyPortalIssuedTicketsSummary.runtime = protobuf_1.proto3;
LegacyPortalIssuedTicketsSummary.typeName = "spwn.dashboard.v1.LegacyPortalIssuedTicketsSummary";
LegacyPortalIssuedTicketsSummary.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ticket_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "purchased_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "checked_in_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "checked_in_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "redeemable_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "redeemed_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "redeemed_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
]);
/**
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardEventSalesDetail
 */
class LegacyPortalDashboardEventSalesDetail extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 商品種別
         *
         * @generated from field: spwn.dashboard.v1.LegacyPortalDashboardProductType product_type = 1;
         */
        this.productType = LegacyPortalDashboardProductType.UNSPECIFIED;
        /**
         * 商品名
         *
         * @generated from field: string product_name = 2;
         */
        this.productName = "";
        /**
         * 商品単価
         *
         * @generated from field: double price = 3;
         */
        this.price = 0;
        /**
         * 購入数量
         *
         * @generated from field: int32 quantity = 4;
         */
        this.quantity = 0;
        /**
         * ユニーク購入ユーザー数
         *
         * @generated from field: int32 unique_purchase_user_count = 5;
         */
        this.uniquePurchaseUserCount = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardEventSalesDetail().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardEventSalesDetail().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardEventSalesDetail().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardEventSalesDetail, a, b);
    }
}
exports.LegacyPortalDashboardEventSalesDetail = LegacyPortalDashboardEventSalesDetail;
LegacyPortalDashboardEventSalesDetail.runtime = protobuf_1.proto3;
LegacyPortalDashboardEventSalesDetail.typeName = "spwn.dashboard.v1.LegacyPortalDashboardEventSalesDetail";
LegacyPortalDashboardEventSalesDetail.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "product_type", kind: "enum", T: protobuf_1.proto3.getEnumType(LegacyPortalDashboardProductType) },
    { no: 2, name: "product_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "unique_purchase_user_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardTicketSalesByOrderDate
 */
class LegacyPortalDashboardTicketSalesByOrderDate extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 注文確定日(updateAtを参照する)
         * 注文日時をJSTの日付で集計し、その日付の 00:00:00.000 JST を Unix epoch milliseconds（UTC基準）で表す。
         *
         * @generated from field: int64 order_date = 1;
         */
        this.orderDate = protobuf_1.protoInt64.zero;
        /**
         * チケット名
         *
         * @generated from field: string ticket_name = 2;
         */
        this.ticketName = "";
        /**
         * 販売枚数
         *
         * @generated from field: int32 quantity = 3;
         */
        this.quantity = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardTicketSalesByOrderDate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardTicketSalesByOrderDate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardTicketSalesByOrderDate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardTicketSalesByOrderDate, a, b);
    }
}
exports.LegacyPortalDashboardTicketSalesByOrderDate = LegacyPortalDashboardTicketSalesByOrderDate;
LegacyPortalDashboardTicketSalesByOrderDate.runtime = protobuf_1.proto3;
LegacyPortalDashboardTicketSalesByOrderDate.typeName = "spwn.dashboard.v1.LegacyPortalDashboardTicketSalesByOrderDate";
LegacyPortalDashboardTicketSalesByOrderDate.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_date", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "ticket_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardGenderCount
 */
class LegacyPortalDashboardGenderCount extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 登録性別
         *
         * @generated from field: spwn.dashboard.v1.LegacyPortalDashboardGender gender = 1;
         */
        this.gender = LegacyPortalDashboardGender.UNSPECIFIED;
        /**
         * ユーザー数
         *
         * @generated from field: int32 count = 2;
         */
        this.count = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardGenderCount().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardGenderCount().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardGenderCount().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardGenderCount, a, b);
    }
}
exports.LegacyPortalDashboardGenderCount = LegacyPortalDashboardGenderCount;
LegacyPortalDashboardGenderCount.runtime = protobuf_1.proto3;
LegacyPortalDashboardGenderCount.typeName = "spwn.dashboard.v1.LegacyPortalDashboardGenderCount";
LegacyPortalDashboardGenderCount.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "gender", kind: "enum", T: protobuf_1.proto3.getEnumType(LegacyPortalDashboardGender) },
    { no: 2, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardAgeGroupGenderCount
 */
class LegacyPortalDashboardAgeGroupGenderCount extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 年齢層
         *
         * @generated from field: spwn.dashboard.v1.LegacyPortalDashboardAgeGroup age_group = 1;
         */
        this.ageGroup = LegacyPortalDashboardAgeGroup.UNSPECIFIED;
        /**
         * 登録性別
         *
         * @generated from field: spwn.dashboard.v1.LegacyPortalDashboardGender gender = 2;
         */
        this.gender = LegacyPortalDashboardGender.UNSPECIFIED;
        /**
         * ユーザー数
         *
         * @generated from field: int32 count = 3;
         */
        this.count = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardAgeGroupGenderCount().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardAgeGroupGenderCount().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardAgeGroupGenderCount().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardAgeGroupGenderCount, a, b);
    }
}
exports.LegacyPortalDashboardAgeGroupGenderCount = LegacyPortalDashboardAgeGroupGenderCount;
LegacyPortalDashboardAgeGroupGenderCount.runtime = protobuf_1.proto3;
LegacyPortalDashboardAgeGroupGenderCount.typeName = "spwn.dashboard.v1.LegacyPortalDashboardAgeGroupGenderCount";
LegacyPortalDashboardAgeGroupGenderCount.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "age_group", kind: "enum", T: protobuf_1.proto3.getEnumType(LegacyPortalDashboardAgeGroup) },
    { no: 2, name: "gender", kind: "enum", T: protobuf_1.proto3.getEnumType(LegacyPortalDashboardGender) },
    { no: 3, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardPrefectureCount
 */
class LegacyPortalDashboardPrefectureCount extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 都道府県
         *
         * @generated from field: spwn.dashboard.v1.LegacyPortalDashboardPrefecture prefecture = 1;
         */
        this.prefecture = LegacyPortalDashboardPrefecture.UNSPECIFIED;
        /**
         * ユーザー数
         *
         * @generated from field: int32 count = 2;
         */
        this.count = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardPrefectureCount().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardPrefectureCount().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardPrefectureCount().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardPrefectureCount, a, b);
    }
}
exports.LegacyPortalDashboardPrefectureCount = LegacyPortalDashboardPrefectureCount;
LegacyPortalDashboardPrefectureCount.runtime = protobuf_1.proto3;
LegacyPortalDashboardPrefectureCount.typeName = "spwn.dashboard.v1.LegacyPortalDashboardPrefectureCount";
LegacyPortalDashboardPrefectureCount.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "prefecture", kind: "enum", T: protobuf_1.proto3.getEnumType(LegacyPortalDashboardPrefecture) },
    { no: 2, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardTicketQuestionnaireQuestion
 */
class LegacyPortalDashboardTicketQuestionnaireQuestion extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 設問ID
         *
         * @generated from field: string question_id = 1;
         */
        this.questionId = "";
        /**
         * 設問文
         *
         * @generated from field: string text = 2;
         */
        this.text = "";
        /**
         * 設問種別
         *
         * @generated from field: spwn.dashboard.v1.LegacyPortalDashboardTicketQuestionAnswerType type = 3;
         */
        this.type = LegacyPortalDashboardTicketQuestionAnswerType.UNSPECIFIED;
        /**
         * 設問種別に応じた回答情報
         *
         * @generated from oneof spwn.dashboard.v1.LegacyPortalDashboardTicketQuestionnaireQuestion.answer_values
         */
        this.answerValues = { case: undefined };
        /**
         * 回答集計元のイベントID。設問定義が一致する複数イベントを合算した場合は、requestのイベントID順で複数件になる。
         *
         * @generated from field: repeated string source_event_ids = 6;
         */
        this.sourceEventIds = [];
        /**
         * Backendが確定した0始まりの表示順。
         *
         * @generated from field: int32 display_order = 7;
         */
        this.displayOrder = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardTicketQuestionnaireQuestion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardTicketQuestionnaireQuestion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardTicketQuestionnaireQuestion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardTicketQuestionnaireQuestion, a, b);
    }
}
exports.LegacyPortalDashboardTicketQuestionnaireQuestion = LegacyPortalDashboardTicketQuestionnaireQuestion;
LegacyPortalDashboardTicketQuestionnaireQuestion.runtime = protobuf_1.proto3;
LegacyPortalDashboardTicketQuestionnaireQuestion.typeName = "spwn.dashboard.v1.LegacyPortalDashboardTicketQuestionnaireQuestion";
LegacyPortalDashboardTicketQuestionnaireQuestion.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "type", kind: "enum", T: protobuf_1.proto3.getEnumType(LegacyPortalDashboardTicketQuestionAnswerType) },
    { no: 4, name: "select_answer_aggregation", kind: "message", T: LegacyPortalDashboardTicketQuestionnaireSelectAnswerAggregation, oneof: "answer_values" },
    { no: 5, name: "text_answers", kind: "message", T: LegacyPortalDashboardTicketQuestionnaireTextAnswers, oneof: "answer_values" },
    { no: 6, name: "source_event_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "display_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardTicketQuestionnaireSelectAnswerAggregation
 */
class LegacyPortalDashboardTicketQuestionnaireSelectAnswerAggregation extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 設定済み選択肢。設問マスタの設定順。
         *
         * @generated from field: repeated string options = 1;
         */
        this.options = [];
        /**
         * 実際に回答された値ごとの回答数。設定済み選択肢順。
         *
         * @generated from field: repeated spwn.dashboard.v1.LegacyPortalDashboardTicketQuestionnaireAnswerCount answer_counts = 2;
         */
        this.answerCounts = [];
        /**
         * 券種ごとの回答集計。
         *
         * @generated from field: repeated spwn.dashboard.v1.LegacyPortalDashboardTicketQuestionnaireTicketAnswerAggregation ticket_answer_aggregations = 3;
         */
        this.ticketAnswerAggregations = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardTicketQuestionnaireSelectAnswerAggregation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardTicketQuestionnaireSelectAnswerAggregation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardTicketQuestionnaireSelectAnswerAggregation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardTicketQuestionnaireSelectAnswerAggregation, a, b);
    }
}
exports.LegacyPortalDashboardTicketQuestionnaireSelectAnswerAggregation = LegacyPortalDashboardTicketQuestionnaireSelectAnswerAggregation;
LegacyPortalDashboardTicketQuestionnaireSelectAnswerAggregation.runtime = protobuf_1.proto3;
LegacyPortalDashboardTicketQuestionnaireSelectAnswerAggregation.typeName = "spwn.dashboard.v1.LegacyPortalDashboardTicketQuestionnaireSelectAnswerAggregation";
LegacyPortalDashboardTicketQuestionnaireSelectAnswerAggregation.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "options", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "answer_counts", kind: "message", T: LegacyPortalDashboardTicketQuestionnaireAnswerCount, repeated: true },
    { no: 3, name: "ticket_answer_aggregations", kind: "message", T: LegacyPortalDashboardTicketQuestionnaireTicketAnswerAggregation, repeated: true },
]);
/**
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardTicketQuestionnaireTextAnswers
 */
class LegacyPortalDashboardTicketQuestionnaireTextAnswers extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * ページネーション用の全体件数
         *
         * @generated from field: int32 total_count = 1;
         */
        this.totalCount = 0;
        /**
         * 回答本文と購入券種・購入者属性を対応付けた回答一覧。Backendが確定した順序。
         *
         * @generated from field: repeated spwn.dashboard.v1.LegacyPortalDashboardTicketQuestionnaireTextAnswer answer_details = 2;
         */
        this.answerDetails = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardTicketQuestionnaireTextAnswers().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardTicketQuestionnaireTextAnswers().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardTicketQuestionnaireTextAnswers().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardTicketQuestionnaireTextAnswers, a, b);
    }
}
exports.LegacyPortalDashboardTicketQuestionnaireTextAnswers = LegacyPortalDashboardTicketQuestionnaireTextAnswers;
LegacyPortalDashboardTicketQuestionnaireTextAnswers.runtime = protobuf_1.proto3;
LegacyPortalDashboardTicketQuestionnaireTextAnswers.typeName = "spwn.dashboard.v1.LegacyPortalDashboardTicketQuestionnaireTextAnswers";
LegacyPortalDashboardTicketQuestionnaireTextAnswers.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "answer_details", kind: "message", T: LegacyPortalDashboardTicketQuestionnaireTextAnswer, repeated: true },
]);
/**
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardTicketQuestionnaireAnswerCount
 */
class LegacyPortalDashboardTicketQuestionnaireAnswerCount extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 実際に回答された値。
         *
         * @generated from field: string answer = 1;
         */
        this.answer = "";
        /**
         * 回答したユーザー数。
         *
         * @generated from field: int32 count = 2;
         */
        this.count = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardTicketQuestionnaireAnswerCount().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardTicketQuestionnaireAnswerCount().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardTicketQuestionnaireAnswerCount().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardTicketQuestionnaireAnswerCount, a, b);
    }
}
exports.LegacyPortalDashboardTicketQuestionnaireAnswerCount = LegacyPortalDashboardTicketQuestionnaireAnswerCount;
LegacyPortalDashboardTicketQuestionnaireAnswerCount.runtime = protobuf_1.proto3;
LegacyPortalDashboardTicketQuestionnaireAnswerCount.typeName = "spwn.dashboard.v1.LegacyPortalDashboardTicketQuestionnaireAnswerCount";
LegacyPortalDashboardTicketQuestionnaireAnswerCount.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "answer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardTicketQuestionnaireTicket
 */
class LegacyPortalDashboardTicketQuestionnaireTicket extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 券種ID。
         *
         * @generated from field: string ticket_id = 1;
         */
        this.ticketId = "";
        /**
         * 券種名。
         *
         * @generated from field: string ticket_name = 2;
         */
        this.ticketName = "";
        /**
         * 券種が所属するイベントID。
         *
         * @generated from field: string event_id = 3;
         */
        this.eventId = "";
        /**
         * 券種の商品種別。配信チケットまたは会場チケット。
         *
         * @generated from field: spwn.dashboard.v1.LegacyPortalDashboardProductType product_type = 4;
         */
        this.productType = LegacyPortalDashboardProductType.UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardTicketQuestionnaireTicket().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardTicketQuestionnaireTicket().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardTicketQuestionnaireTicket().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardTicketQuestionnaireTicket, a, b);
    }
}
exports.LegacyPortalDashboardTicketQuestionnaireTicket = LegacyPortalDashboardTicketQuestionnaireTicket;
LegacyPortalDashboardTicketQuestionnaireTicket.runtime = protobuf_1.proto3;
LegacyPortalDashboardTicketQuestionnaireTicket.typeName = "spwn.dashboard.v1.LegacyPortalDashboardTicketQuestionnaireTicket";
LegacyPortalDashboardTicketQuestionnaireTicket.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ticket_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "product_type", kind: "enum", T: protobuf_1.proto3.getEnumType(LegacyPortalDashboardProductType) },
]);
/**
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardTicketQuestionnaireTicketAnswerAggregation
 */
class LegacyPortalDashboardTicketQuestionnaireTicketAnswerAggregation extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * この設問へ回答した券種内のユーザー数。
         *
         * @generated from field: int32 respondent_count = 2;
         */
        this.respondentCount = 0;
        /**
         * 実回答値ごとの回答数。設定済み選択肢順。
         *
         * @generated from field: repeated spwn.dashboard.v1.LegacyPortalDashboardTicketQuestionnaireAnswerCount answer_counts = 3;
         */
        this.answerCounts = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardTicketQuestionnaireTicketAnswerAggregation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardTicketQuestionnaireTicketAnswerAggregation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardTicketQuestionnaireTicketAnswerAggregation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardTicketQuestionnaireTicketAnswerAggregation, a, b);
    }
}
exports.LegacyPortalDashboardTicketQuestionnaireTicketAnswerAggregation = LegacyPortalDashboardTicketQuestionnaireTicketAnswerAggregation;
LegacyPortalDashboardTicketQuestionnaireTicketAnswerAggregation.runtime = protobuf_1.proto3;
LegacyPortalDashboardTicketQuestionnaireTicketAnswerAggregation.typeName = "spwn.dashboard.v1.LegacyPortalDashboardTicketQuestionnaireTicketAnswerAggregation";
LegacyPortalDashboardTicketQuestionnaireTicketAnswerAggregation.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "ticket", kind: "message", T: LegacyPortalDashboardTicketQuestionnaireTicket },
    { no: 2, name: "respondent_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "answer_counts", kind: "message", T: LegacyPortalDashboardTicketQuestionnaireAnswerCount, repeated: true },
]);
/**
 * @generated from message spwn.dashboard.v1.LegacyPortalDashboardTicketQuestionnaireTextAnswer
 */
class LegacyPortalDashboardTicketQuestionnaireTextAnswer extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 自由記入の回答本文。
         *
         * @generated from field: string answer = 1;
         */
        this.answer = "";
        /**
         * 回答者が同一イベントで購入した券種。Backendが確定した順序。
         *
         * @generated from field: repeated spwn.dashboard.v1.LegacyPortalDashboardTicketQuestionnaireTicket tickets = 2;
         */
        this.tickets = [];
        /**
         * 回答者の年齢層。
         *
         * @generated from field: spwn.dashboard.v1.LegacyPortalDashboardAgeGroup age_group = 3;
         */
        this.ageGroup = LegacyPortalDashboardAgeGroup.UNSPECIFIED;
        /**
         * 回答者の登録性別。
         *
         * @generated from field: spwn.dashboard.v1.LegacyPortalDashboardGender gender = 4;
         */
        this.gender = LegacyPortalDashboardGender.UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalDashboardTicketQuestionnaireTextAnswer().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalDashboardTicketQuestionnaireTextAnswer().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalDashboardTicketQuestionnaireTextAnswer().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalDashboardTicketQuestionnaireTextAnswer, a, b);
    }
}
exports.LegacyPortalDashboardTicketQuestionnaireTextAnswer = LegacyPortalDashboardTicketQuestionnaireTextAnswer;
LegacyPortalDashboardTicketQuestionnaireTextAnswer.runtime = protobuf_1.proto3;
LegacyPortalDashboardTicketQuestionnaireTextAnswer.typeName = "spwn.dashboard.v1.LegacyPortalDashboardTicketQuestionnaireTextAnswer";
LegacyPortalDashboardTicketQuestionnaireTextAnswer.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "answer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tickets", kind: "message", T: LegacyPortalDashboardTicketQuestionnaireTicket, repeated: true },
    { no: 3, name: "age_group", kind: "enum", T: protobuf_1.proto3.getEnumType(LegacyPortalDashboardAgeGroup) },
    { no: 4, name: "gender", kind: "enum", T: protobuf_1.proto3.getEnumType(LegacyPortalDashboardGender) },
    { no: 5, name: "last_answered_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
]);
//# sourceMappingURL=legacy_portal_common_pb.js.map